<template>
  <sk-layout :menu="menuFirst" :showMenu="showMenu" :path="path" :subMenu="menuSecond" @logout="logout">
    <router-view></router-view>
  </sk-layout>
</template>

<script>
export default {
  data () {
    return {
      menuFirst: [],
      showMenu: false
    }
  },
  created () {
    this.menuFirst = this.$store.state.permission.menuFirst
  },
  computed: {
    path () {
      return this.$store.state.permission.menuPath.path
    },
    menuSecond () {
      return this.$store.state.permission.menuSecond[this.$store.state.permission.menuPath.path]
    }
  },
  methods: {
    logout () {
      this.$skprompt({
        title: '退出提醒',
        describe: '是否确定退出登录',
        btName: '退出'
      }).then(() => {
        return this.$store.dispatch('LogOut')
      }).then(() => location.reload())
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layout/layout.vue